import * as React from 'react';
import { TextInput, Select } from "soprasteria-ui-library";
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { ICareProvider } from '../../../../models/ICareProvider';
import { ISpeciality } from '../../../../models/IReferral';
import { IAddress } from '../../../../models/IAddress';


interface IReferralRecipentSectionManualRegistration {
    specialties: ISpeciality[];
    careProvider: ICareProvider;
}

export const ReferralRecipentSectionManualRegistration: React.FunctionComponent<IReferralRecipentSectionManualRegistration> = ({ specialties, careProvider }) => {

    const formatAddress = (address?: IAddress): string => {
        if (address?.address === undefined || address?.zipCode === undefined || address?.city === undefined) {
            return "";
        }
        return `${address?.address?.trim()}, ${address?.zipCode} ${address?.city}`;
    }

    return (
        <div className="row readonly-less-margin">
            <h5 className="col-12">Remissmottagare</h5>
            <div className="col-6">
                <TextInput name="recipentCareProviderReadonly" label="Mottagning" defaultValue={careProvider.name} readonly inlineLabel />
            </div>
            <div className="col-6">
                <Select name="specialityId"
                    label="Specialitet"
                    options={specialties.map<IListItem>((specialty) => { return { text: specialty.specialityName, value: specialty.specialityId.toString() } })}
                    placeholder="Välj en specialitet"
                    inlineLabel
                    required
                />
            </div>

            <div className="col-6">
                <TextInput name="careProviderAddressReadonly" label="Mottagningens adress" defaultValue={formatAddress(careProvider.address)} inlineLabel readonly />
            </div>
        </div>

    )
}
